import clsx from 'clsx';
import { Typography } from '@ag1/ui';
import { type ImageContentHighlight } from 'types/studio/studio';
import { CustomPortableText } from 'shared/studio/PortableText';
import { UnifiedButton, type UnifiedButtonType } from 'shared/studio/UnifiedButton';
import ImageContentHighlightCard from '../ImageContentHighlightCard/ImageContentHighlightCard';
import * as styles from './ImageContentHighlightBody.css';

type ImageContentHighlightBodyProps = {
  sectionType: ImageContentHighlight['_type'];
  isDarkMode: boolean;
} & Pick<
  ImageContentHighlight,
  'bodyTitle' | 'bodyText' | 'cards' | 'unifiedButton' | 'showAdditionalButton' | 'additionalButton'
>;

const ImageContentHighlightBody = ({
  sectionType,
  isDarkMode,
  bodyTitle,
  bodyText,
  cards,
  unifiedButton,
  showAdditionalButton,
  additionalButton
}: ImageContentHighlightBodyProps) => (
  <div>
    {bodyTitle && (
      <Typography variant="headlineSans" size="3" noPadding className={styles.bodyTitle}>
        <CustomPortableText addAccessibility value={bodyTitle} />
      </Typography>
    )}

    {bodyText && (
      <Typography
        variant="portalSubtitle"
        size="2"
        noPadding
        className={clsx(styles.bodyText, isDarkMode && styles.bodyTextDarkMode)}>
        <CustomPortableText addAccessibility value={bodyText} />
      </Typography>
    )}

    {cards && cards.length > 0 && <ImageContentHighlightCard cards={cards} />}

    <div className={styles.buttonsWrapper}>
      {unifiedButton && (
        <UnifiedButton unifiedButton={unifiedButton} sectionType={sectionType} size="medium" />
      )}
      {showAdditionalButton && additionalButton && (
        <UnifiedButton
          unifiedButton={additionalButton as unknown as UnifiedButtonType}
          sectionType={sectionType}
          size="medium"
        />
      )}
    </div>
  </div>
);

export default ImageContentHighlightBody;
